import { AxiosRequestConfig } from 'axios';

export const getAxiosParams = (params?: Record<string, any>): AxiosRequestConfig | undefined => {
  if (
    !params ||
    !Object.values(params).length ||
    Object.values(params).every((param) => typeof param === 'undefined')
  ) {
    return;
  }

  return { params };
};
